<template>
    <Toast />
    <Dialog v-model:visible="showErrorDialog" modal :header="'Terjadi Kesalahan'" :closable="true"
        class="w-[90vw] md:w-[50vw]">
        <div class="flex items-start space-x-3">
            <ExclamationCircleIcon class="h-6 w-6 text-red-500" />
            <p class="text-gray-700 dark:text-gray-200">{{ errorMessage }}</p>
        </div>
        <template #footer>
            <Button label="Tutup" @click="showErrorDialog = false" severity="secondary" />
        </template>
    </Dialog>
    <IndexView />
    <div id="overlay" class="fixed inset-0 bg-black bg-opacity-30 z-30" :class="{ 'hidden': !isBlur }"></div>
    <ViewContainer>
        <section class="p-4">
            <!-- Compact Dashboard Grid -->
            <div class="grid grid-cols-1 xl:grid-cols-12 gap-4">
                <!-- Cash Register Section - Compact -->
                <div v-if="isCashRegisterVisible" class="xl:col-span-5">
                    <CashRegister @showDialog="showModalDialog" />
                </div>
                
                <!-- Orders Section - Takes remaining space -->
                <div v-if="isOrderVisible" class="xl:col-span-7">
                    <div class="bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-dark-900 dark:border-dark-700">
                        <!-- Compact Header -->
                        <div class="px-4 py-3 border-b border-gray-100 dark:border-dark-700">
                            <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                                <h3 class="text-lg font-semibold text-gray-900 dark:text-dark-100">Orders</h3>
                                <SearchBox
                                    v-model="searchOrder"
                                    placeholder="Search orders..."
                                    class-div="w-full max-w-none sm:max-w-sm"
                                    class-add="w-full sm:w-64"
                                />
                            </div>
                        </div>
                        <!-- Compact List -->
                        <div class="p-4">
                            <ListOrder :searchOrder="searchOrder" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </ViewContainer>
</template>

<script>
import IndexView from '@/views/IndexView.vue';
import CashRegister from '@/components/card-dashboard/cash-register/CashRegister.vue';
import { Button, Dialog, Toast } from 'primevue';
import ViewContainer from '@/components/ViewContainer.vue';
import ListOrder from './new-transaction/order/ListOrder.vue';
import SearchBox from './new-transaction/SearchBox.vue';

export default {
    name: 'DashboardView',
    components: {
        IndexView, CashRegister, Dialog, Toast, Button, ViewContainer, ListOrder, SearchBox
    },
    computed: {
        isCashRegisterVisible() {
            return localStorage.getItem('role_id') !== "null";
        },
        isOrderVisible() {
            return localStorage.getItem('role_id') !== "null";
        },
    },
    data() {
        return {
            showErrorDialog: false,
            errorMessage: '',
            isBlur: false,
            searchOrder: '',
            tables: [
                { id: 1, name: 'Table 1', status: 'Available' },
                { id: 2, name: 'Table 2', status: 'Occupied' },
                { id: 3, name: 'Table 3', status: 'Available' },
                { id: 4, name: 'Table 4', status: 'Occupied' },
                { id: 5, name: 'Table 5', status: 'Available' },
            ],
        };
    },
    methods: {
        toggleBlur() {
            this.isBlur = !this.isBlur;
        },
        showModalDialog(errors) {
            this.showErrorDialog = true;
            this.errorMessage = errors;
        }
    }
}
</script>